import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["number"]
  static values = {
    end: Number,
    duration: { type: Number, default: 2 }
  }

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.startCount()
            this.observer.disconnect()
          }
        })
      },
      { threshold: 0.5 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.animationFrame) cancelAnimationFrame(this.animationFrame)
  }

  startCount() {
    const start = 0
    const end = this.endValue
    const duration = this.durationValue * 1000
    const startTime = performance.now()

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)
      const eased = this.easeOutQuart(progress)
      const current = Math.round(start + (end - start) * eased)

      if (this.hasNumberTarget) {
        this.numberTarget.textContent = current.toLocaleString('ko-KR')
      }

      if (progress < 1) {
        this.animationFrame = requestAnimationFrame(animate)
      }
    }

    this.animationFrame = requestAnimationFrame(animate)
  }

  easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4)
  }
}
